import type { ReactNode } from "react";

import { Breadcrumb } from "@/components/ui/breadcrumbs";
import { Section } from "../Section";

export type BillingDetailTab = "invoices" | "master-invoices";

const billingHref = {
  invoices: {
    to: "/admin/billing",
    search: { t: "invoices" },
  },
  "master-invoices": {
    to: "/admin/billing",
    search: { t: "master-invoices" },
  },
} as const;

type BillingDetailShellProps = {
  billingTab: BillingDetailTab;
  breadcrumbTail: ReactNode;
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
};

/** Breadcrumb + title for admin billing detail routes. */
export function BillingDetailShell({
  billingTab,
  breadcrumbTail,
  title,
  actions,
  children,
}: BillingDetailShellProps) {
  return (
    <>
      <Section.Title
        breadcrumb={
          <>
            <Breadcrumb href={billingHref[billingTab]}>Billing</Breadcrumb>
            <Breadcrumb>{breadcrumbTail}</Breadcrumb>
          </>
        }
        actions={actions}
      >
        {title}
      </Section.Title>
      {children}
    </>
  );
}
